export default "__VITE_ASSET__BRLJfCOy__"